import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import flooringService from './flooringService'

const initialState = {
	flooring: [],
	isError: false,
	isSuccess: false,
	isLoading: false,
	message: '',
}

export const getFlooring = createAsyncThunk('images/getFlooring', async (thunkAPI) => {
	try {
		return await flooringService.getFlooring()
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString()

		return thunkAPI.rejectWithValue(message)
	}
})

export const flooringSlice = createSlice({
	name: 'flooring',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(getFlooring.pending, (state) => {
				state.isLoading = true
			})
			.addCase(getFlooring.fulfilled, (state, action) => {
				state.isLoading = false
				state.isSuccess = true
				state.flooring = action.payload
			})
			.addCase(getFlooring.rejected, (state, action) => {
				state.isLoading = false
				state.isError = true
				state.flooring = []
				state.message = action.payload
			})
	},
})

export default flooringSlice.reducer
